<template>
    <v-dialog
        :value="isOpenDetails"
        @click:outside="closeDialog"
        max-width="600"
    >
        <v-card>
            <v-card-title class="pa-0 shadow-1">
                <v-img
                    :src="require('@/assets/illustrations/bg_modal_card.svg')"
                    cover
                    position="left bottom"
                    class="align-center"
                    height="65px"
                >
                    <v-card-title class="font-weight-medium primary--text">
                        Detalles de Mensaje
                    </v-card-title>
                </v-img>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="6" class="primary--text">
                        Creado Por:
                    </v-col>
                    <v-col cols="6">{{ item.owner.name }}</v-col>
                    <v-col cols="6" class="primary--text">
                        Titulo:
                    </v-col>
                    <v-col cols="6">{{ item.title }}</v-col>
                    <v-col cols="6" class="primary--text">
                        Mensaje:
                    </v-col>
                    <v-col cols="6">{{ item.text }}</v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="closeDialog" color="error" text>
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        isOpenDetails: {
            type: Boolean
        },
        item: {
            type: Object
        }
    },
    methods: {
        closeDialog() {
            this.$emit("dialog:close");
        }
    }
};
</script>

<style></style>
